<template>
  <v-menu :close-on-content-click="false">
    <template #activator="{ props }">
      <v-btn
        icon
        v-bind="props"
        class="settings-btn"
        aria-label="Settings"
      >
        <v-icon size="26">mdi-cog</v-icon>
      </v-btn>
    </template>
    <v-card class="settings-menu-card pa-3 mt-1">
      <!-- Theme Toggle -->
      <div class="settings-section">
        <div class="settings-label">{{ $t("theme") }}</div>
        <v-btn-toggle
          mandatory
          rounded
          v-model="localTheme"
          class="modern-toggle"
          @update:modelValue="onThemeChange"
        >
          <v-btn
            :value="'dark'"
            class="modern-toggle-btn"
            :class="{ active: isDark }"
          >
            <v-icon size="22">mdi-weather-night</v-icon>
            <span class="toggle-label">{{ $t("dark") }}</span>
          </v-btn>
          <v-btn
            :value="'light'"
            class="modern-toggle-btn"
            :class="{ active: !isDark }"
          >
            <v-icon size="22">mdi-white-balance-sunny</v-icon>
            <span class="toggle-label">{{ $t("light") }}</span>
          </v-btn>
        </v-btn-toggle>
      </div>
      <!-- Environment Toggle -->
      <div class="settings-section mt-3" v-if="isAdmin">
        <div class="settings-label">{{ $t("environment") }}</div>
        <v-btn-toggle
          mandatory
          rounded
          v-model="localEnv"
          class="modern-toggle env-btn-toggle"
          @update:modelValue="onEnvChange"
          density="compact"
        >
          <v-btn
            value="PROD"
            class="modern-toggle-btn env-toggle-btn"
            :class="{ active: localEnv === 'PROD' }"
            color="success"
            variant="flat"
            size="small"
            height="32"
          >
            <span class="env-label">PROD</span>
          </v-btn>
          <v-btn
            value="PREPROD"
            class="modern-toggle-btn env-toggle-btn"
            :class="{ active: localEnv === 'PREPROD' }"
            color="warning"
            variant="flat"
            size="small"
            height="32"
          >
            <span class="env-label">PREPROD</span>
          </v-btn>
        </v-btn-toggle>
      </div>
      <!-- Language Toggle -->
      <div class="settings-section mt-3">
        <div class="settings-label">{{ $t("selectLanguage") }}</div>
        <v-btn-toggle
          mandatory
          rounded
          v-model="localLang"
          class="modern-toggle lang-btn-toggle"
          @update:modelValue="onLangChange"
        >
          <v-btn
            v-for="lang in languageOptions"
            :key="lang.value"
            :value="lang.value"
            class="modern-toggle-btn lang-toggle-btn"
            :class="{ active: localLang === lang.value }"
          >
            <span class="lang-flag">
              <flag
                :iso="lang.flag"
                :squared="false"
                style="width: 26px; height: 18px"
              />
            </span>
            <span class="lang-short-label">{{
              lang.label.toUpperCase()
            }}</span>
          </v-btn>
        </v-btn-toggle>
      </div>
      
      <v-divider class="my-3"></v-divider>
      
      <!-- Logout Button -->
      <div class="settings-section text-center">
        <v-btn
          color="error"
          variant="tonal"
          prepend-icon="mdi-logout"
          @click="$emit('logout')"
          block
          rounded
        >
          {{ $t("logout") }}
        </v-btn>
      </div>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: 'NavBarSettings',
  props: {
    themeToggle: String,
    isDark: Boolean,
    langToggle: String,
    languageOptions: Array,
    currentEnv: String,
    isAdmin: Boolean
  },
  data() {
    return {
      localTheme: this.themeToggle,
      localLang: this.langToggle,
      localEnv: this.currentEnv || 'PROD'
    };
  },
  watch: {
    themeToggle(val) {
      this.localTheme = val;
    },
    langToggle(val) {
      this.localLang = val;
    },
    currentEnv(val) {
      this.localEnv = val;
    }
  },
  methods: {
    onThemeChange(val) {
      this.$emit('toggle-theme', val);
    },
    onLangChange(val) {
      this.$emit('set-locale', val);
    },
    onEnvChange(val) {
      this.$emit('set-environment', val);
    }
  }
};
</script>
<style scoped>
.settings-btn { margin-right: 8px; }
.env-toggle-btn {
  min-width: 80px !important;
  max-width: 80px !important;
  font-size: 0.85em; 
  letter-spacing: 0.5px;
  padding: 0 8px;
}
</style> 